/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
// tslint:disable:object-literal-sort-keys
/**
 * The four basic intents.
 */
export var Intent = {
    NONE: "none",
    PRIMARY: "primary",
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger",
};
//# sourceMappingURL=intent.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blueprintjs/core/lib/esm/common/intent.js
// module id = 53
// module chunks = 0